import {$window, $body} from '../../../Constants';
import SwiperSlider from '../../../Elements/SwiperSlider';

/**
 * Member Slider
 */
const MemberSlider = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		MEMBER_SLIDER: '.team-member-slider.swiper-container',
	};

	/**
	 * Class Name
	 *
	 * @var { Object }
	 */
	const ClassName = {
		CAN_CENTER: 'can-center'
	};

	/**
	 * Member Slider
	 *
	 * @class
	 * @augments SwiperSlider
	 */
	class MemberSlider extends SwiperSlider {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			this.$element.addClass(`slides-count-${this.$element.find('.swiper-slide').length}`);
			this.setOptions({
				spaceBetween: !this.$element.hasClass('collapse') ? 30 : 0,
				slidesPerView: this.$element.data('cols-xxlarge'),
				grabCursor: true,
				pagination: {
					el: `${Selector.MEMBER_SLIDER} ${this.constructor.Selector.PAGINATION}`,
					clickable: true
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},
				autoplay: {
					delay: 5000,
					disableOnInteraction: false
				},
				breakpoints: {
					1600: {
						slidesPerView: this.$element.data('cols-xxlarge')
					},
					1439: {
						slidesPerView: this.$element.data('cols-xlarge')
					},
					1199: {
						slidesPerView: this.$element.data('cols-large')
					},
					1023: {
						slidesPerView: this.$element.data('cols-medium')
					},
					639: {
						slidesPerView: this.$element.data('cols-xsmall')
					},
					499: {
						slidesPerView: 1
					}
				}
			});

			this._initialize();
			this._bindHandlers();
			this._handleCentering();
		}

		/**
		 * Binds the event handlers to the elements
		 *
		 * @return void
		 */
		_bindHandlers() {
			$window.on('resize', () => {
				this._handleCentering();
			});
		}

		/**
		 * Handles the centering by adding or removing the css class
		 *
		 * @return void
		 */
		_handleCentering() {
			this.$element.toggleClass(ClassName.CAN_CENTER, this.length < this.slider.params.slidesPerView);
		}
	}

	return MemberSlider._getElements($body.find(Selector.MEMBER_SLIDER), MemberSlider);
})();

export default MemberSlider;
